// Royal Kalahari brand tokens (BD-79): the one source, brand.json, for the app, emails and reports.
import tokens from "./brand.json" with { type: "json" };

export type PaletteName = keyof typeof tokens.palette;
export const brand = tokens;

/** A token name or a literal colour, as #RRGGBB. */
export function brandHex(v: string): string {
  const h = (tokens.palette as Record<string, string>)[v] ?? v;
  if (!/^#[0-9A-F]{6}$/i.test(h)) throw new Error(`Not a colour: ${v}`);
  return h.toUpperCase();
}
